export enum BrandNames {
	Codan = 'Codan',
	Privatsikring = 'Privatsikring',
	Almbrand = 'Almbrand',
}
